import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { form_control, ngxMenuItem, Permission, SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { ReportInfo, StimulSoftReportComponent } from "src/app/stimul-soft-report/stimul-soft-report.component";
import { ReportKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { Invoice } from "src/app/frontoffice/order/model/invoice.model";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { takeUntil } from "rxjs/operators";
import { PrintTemplate } from "../model/print-template.model";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";

@Component({
  selector: "ngx-sale-report-desiner",
  templateUrl: "./sale-report-desiner.component.html",
  styleUrls: ["./sale-report-desiner.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaleReportDesinerComponent extends BaseFormComponent<PrintTemplate> {
  constructor(
    private __id: FormContainerModel,
    _tabsservice: TabularService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef
  ) {
    super(selectorService, cd);
    this._id = __id;
    this.tabsservice = _tabsservice;
  }
  rowIsEditing: boolean = false;
  async ngOnInit() {
    this.apiName = "SaleReportDesiner";
    this.label = this.translate("ClientApp.FrontOffice.SaleReportDesigner.SalesReportDesign");
    super.ngOnInit();
  }
  changed($event) {
    if ($event && $event.Name) {
      this.model.PrintTemplateTypeName = $event.Name;
      this.model.PrintTemplateTypeTitle = $event.Title;
    }
  }
  async setColumns() {
    var col: form_control[] = [];
    col = [
      {
        name: "PrintTemplateTypeId",
        modelName: "PrintTemplateTypeId",
        controlType: FormControlTypes.dropdown,
        userClass: "select-md",
        listVisible: false,
        label: this.translate("ClientApp.FrontOffice.SaleReportDesigner.ReportTemplate"),
        order: 0,
        textType: "text",
        withComma: false,
        formVisible: true,
        disabled: false,
        areaName: undefined,
        apiName: "PrintTemplate/ReadPrintTemplateLookup",
        displayMember: "Title",
        valueMember: "Id",
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    this.columns = col;
    this.orignalColumns = col;
  }
  createReport() {
    let saveReportFile: SaveReportFile = <SaveReportFile>{};
    saveReportFile.ReportTitle = this.label;
    saveReportFile.FileName = "Invoice";
    saveReportFile.SystemKindName = "SALE";
    saveReportFile.CategoryName = "Invoice";

    if (!this.model.PrintTemplateTypeName) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SaleReportDesigner.PrintPatternNotSelected"),
        this.translate("ClientApp.FrontOffice.SaleReportDesigner.Error")
      );
      return;
    }
    this.httpCommonService
      .get("Invoice/GetSaleReportDesiner")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            let reportInfo: ReportInfo = <ReportInfo>{};
            reportInfo.reportKind = ReportKind.editReport;
            reportInfo.apiName = "Invoice";
            saveReportFile.FileName = this.model.PrintTemplateTypeName;
            saveReportFile.ReportTitle = this.model.PrintTemplateTypeTitle;
            reportInfo.dataList = [data];
            reportInfo.pathPreFix = "FrontOffice";
            reportInfo.saveReportFile = saveReportFile;
            const menu = <ITab>{
              title: this.model.PrintTemplateTypeTitle,
              isCloseable: true,
              active: true,
              responsive: true,
              componentType: StimulSoftReportComponent,
              // modulePath: MENU_ITEMS[0].target,
              data: [{ provide: ReportInfo, useValue: reportInfo }],
            };
            this.tabsservice.open(menu);
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  async save() {
    this.createReport();
  }
  printReport() {
    if (!this.model.PrintTemplateTypeName) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SaleReportDesigner.PrintPatternNotSelected"),
        this.translate("ClientApp.FrontOffice.SaleReportDesigner.Error")
      );
      return;
    }

    this.httpCommonService
      .get("Invoice/GetSaleReportDesiner")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: Invoice) => {
          if (data) {
            if (!data.Items) data.Items = [];
            this.httpCommonService
              .create("Branch/Print", { PrinterName: "Microsoft Print to PDF", TemplateName: this.model.PrintTemplateTypeName, List: [data] })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(
                (data: Invoice) => {},
                (error) => this.getFailedHelper(error)
              );
            let reportInfo: ReportInfo = <ReportInfo>{};

            let saveReportFile: SaveReportFile = <SaveReportFile>{};
            saveReportFile.ReportTitle = this.label;
            saveReportFile.FileName = "Invoice";
            saveReportFile.SystemKindName = "SALE";
            saveReportFile.CategoryName = "Invoice";

            reportInfo.reportKind = ReportKind.print;
            reportInfo.apiName = "Invoice";
            saveReportFile.FileName = this.model.PrintTemplateTypeName;
            saveReportFile.ReportTitle = this.model.PrintTemplateTypeTitle;
            reportInfo.reportName = this.model.PrintTemplateTypeName;
            reportInfo.reportTitle = this.model.PrintTemplateTypeTitle;
            reportInfo.dataList = [data];
            reportInfo.pathPreFix = "FrontOffice";
            reportInfo.saveReportFile = saveReportFile;
            const menu = <ITab>{
              title: this.model.PrintTemplateTypeTitle,
              isCloseable: true,
              active: true,
              responsive: true,
              componentType: StimulSoftReportComponent,
              // modulePath: MENU_ITEMS[0].target,
              data: [{ provide: ReportInfo, useValue: reportInfo }],
            };
            this.tabsservice.open(menu);
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  previewReport() {
    if (!this.model.PrintTemplateTypeName) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SaleReportDesigner.PrintPatternNotSelected"),
        this.translate("ClientApp.FrontOffice.SaleReportDesigner.Error")
      );
      return;
    }
    let saveReportFile: SaveReportFile = <SaveReportFile>{};
    saveReportFile.ReportTitle = this.label;
    saveReportFile.FileName = "Invoice";
    saveReportFile.SystemKindName = "SALE";
    saveReportFile.CategoryName = "Invoice";

    this.httpCommonService
      .get("Invoice/GetSaleReportDesiner")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: Invoice) => {
          if (data) {
            if (!data.Items) data.Items = [];
            let reportInfo: ReportInfo = <ReportInfo>{};
            reportInfo.reportKind = ReportKind.preview;
            reportInfo.apiName = "Invoice";
            saveReportFile.FileName = this.model.PrintTemplateTypeName;
            saveReportFile.ReportTitle = this.model.PrintTemplateTypeTitle;
            reportInfo.dataList = [data];
            reportInfo.pathPreFix = "FrontOffice";
            reportInfo.saveReportFile = saveReportFile;
            const menu = <ITab>{
              title: this.model.PrintTemplateTypeTitle,
              isCloseable: true,
              active: true,
              responsive: true,
              componentType: StimulSoftReportComponent,
              // modulePath: MENU_ITEMS[0].target,
              data: [{ provide: ReportInfo, useValue: reportInfo }],
            };
            this.tabsservice.open(menu);
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
}
